import _asyncToGenerator from "C:/Users/Administrator/Desktop/work/space-0/fsplus-vue-workspace/foshan-street/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3c3c8094"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "publish-form"
};
var _hoisted_2 = {
  class: "popup-header"
};
var _hoisted_3 = {
  class: "popup-title"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "popup-body"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "option-info"
};
var _hoisted_8 = {
  class: "option-name"
};
var _hoisted_9 = {
  class: "popup-footer"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_11 = {
  class: "popup-header"
};
var _hoisted_12 = {
  class: "popup-title"
};
var _hoisted_13 = ["onClick"];
var _hoisted_14 = {
  class: "popup-body"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = {
  class: "option-info"
};
var _hoisted_17 = {
  class: "option-name"
};
var _hoisted_18 = {
  class: "popup-footer"
};
var _hoisted_19 = {
  key: 0,
  class: "footer-count"
};

var _hoisted_20 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_21 = {
  class: "popup-header"
};
var _hoisted_22 = {
  class: "popup-title"
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = {
  class: "popup-body picker-body"
};
var _hoisted_25 = {
  class: "popup-footer"
};

var _hoisted_26 = /*#__PURE__*/_createTextVNode("确定");

var _hoisted_27 = {
  key: 1,
  class: "popup-empty"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "暂无可选日期", -1);
});

import composition from '@/composition';
import { ref } from 'vue';
export default {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _composition = composition(),
        request = _composition.request; // 表单配置


    var formConfig = ref([]);
    var customFieldName = ref({
      text: 'content',
      value: 'id'
    });
    /**
     * 是否存在表单项
     */

    var hasForm = function hasForm() {
      return !!(formConfig.value && formConfig.value.length > 0);
    };
    /**
     * 获取表单配置
     * @param {number} tagId 话题id
     * @param {boolean} enabled 该话题是否配置了表单（isConfig == 1）
     */


    var getFormConfig = function getFormConfig(tagId) {
      var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!tagId || !enabled) {
        formConfig.value = [];
        return;
      }

      request.getConfigList(tagId).then(function (res) {
        formConfig.value = res.data.configList;

        var _loop = function _loop(i) {
          var cfg = formConfig.value[i];
          cfg.write = '';

          if (cfg.type == 2) {
            // 单选：拉取选项，使用 radio 弹窗
            cfg.showOption = false;
            cfg.radioValue = 0;
            cfg.optionCheckId = 0;
            cfg.option = [];
            request.getPickerList(cfg.id).then(function (r) {
              cfg.option = r.data;
            });
          }

          if (cfg.type == 4) {
            // 多选：拉取选项，使用 checkbox 弹窗
            cfg.showOption = false;
            cfg.checkboxValues = [];
            cfg.optionCheckIds = [];
            cfg.optionCheckId = '';
            cfg.option = [];
            request.getPickerList(cfg.id).then(function (r) {
              cfg.option = r.data;
            });
          }

          if (cfg.type == 5) {
            // 时间选择：根据后端 value + isIntradayOptional 计算可选日期
            cfg.showOption = false;
            cfg.selectedValue = 0;
            cfg.optionCheckId = '';
            cfg.pickerValue = null;
            cfg.dateOptions = computeDateOptions(cfg);
          }

          if (cfg.type == 3) {
            cfg.preview = [];
            cfg.imgList = [];
            cfg.uploadImg = [];
          }
        };

        for (var i = 0; i < formConfig.value.length; i++) {
          _loop(i);
        }
      });
    }; // 单选确认


    var confirmSingle = function confirmSingle(item) {
      var opt = item.option.find(function (o) {
        return o.id === item.radioValue;
      });

      if (opt) {
        item.write = opt.content;
        item.optionCheckId = opt.id;
      }

      item.showOption = false;
    }; // 多选确认：将选中的多个选项 id 用逗号拼接


    var confirmMulti = function confirmMulti(item) {
      var selected = item.option.filter(function (o) {
        return item.checkboxValues.includes(o.id);
      });
      item.optionCheckIds = selected.map(function (o) {
        return o.id;
      });
      item.optionCheckId = item.optionCheckIds.join(',');
      item.write = selected.map(function (o) {
        return o.content;
      }).join(',');
      item.showOption = false;
    }; // 多选：点击整行切换选中态


    var toggleMulti = function toggleMulti(item, optId) {
      var values = item.checkboxValues;
      var idx = values.indexOf(optId);

      if (idx > -1) {
        values.splice(idx, 1);
      } else {
        values.push(optId);
      }
    }; // 时间选择：滚动时记录当前高亮日期


    var onDateChange = function onDateChange(item, val) {
      item.pickerValue = Array.isArray(val) ? val[0] : val;
    }; // 时间选择确认


    var confirmDateClick = function confirmDateClick(item) {
      var selected = item.pickerValue || item.dateOptions[0];
      if (!selected) return;
      item.write = selected.content;
      item.selectedValue = selected.id;
      item.optionCheckId = selected.id;
      item.showOption = false;
    };
    /**
     * 时间戳(ms) → YYYY-MM-DD 字符串
     * 用本地时间字段拼接，避免 toISOString() 带来的 UTC 偏移（东八区会差一天）
     * @param {number} ms
     * @returns {string}
     */


    var formatDateStr = function formatDateStr(ms) {
      var d = new Date(Number(ms));
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(day);
    };
    /**
     * 根据后端配置计算时间选择的可选日期列表
     * @param {object} cfg 表单项，需包含 value(开始#结束 时间戳) 与 isIntradayOptional(0|1)
     * @returns {Array<{id:number, content:string}>}
     */


    var DAY = 24 * 60 * 60 * 1000;

    var computeDateOptions = function computeDateOptions(cfg) {
      if (!cfg.value || cfg.value.indexOf('#') === -1) return [];
      var parts = cfg.value.split('#');
      var backendStart = Number(parts[0]);
      var backendEnd = Number(parts[1]);
      if (!backendStart || !backendEnd) return []; // 以"今日0点"为基准，往后最多7日窗口

      var now = new Date();
      var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      var windowStart = cfg.isIntradayOptional == 1 ? todayStart : todayStart + DAY;
      var windowEnd = windowStart + 6 * DAY; // 可选日期 = 后端范围 ∩ 7日窗口

      var earliest = Math.max(windowStart, backendStart);
      var latest = Math.min(windowEnd, backendEnd);
      if (earliest > latest) return [];
      var list = [];

      for (var d = earliest; d <= latest; d += DAY) {
        var dt = new Date(d);
        list.push({
          id: d,
          content: "".concat(dt.getMonth() + 1, "\u6708").concat(dt.getDate(), "\u65E5")
        });
      }

      return list;
    }; // 图片上传超过最大限制


    var formOversize = function formOversize() {
      _Toast('上传单张图片超过10M');
    };
    /**
     * 表单校验：必填项未完成时直接 throw，由调用方捕获提示
     */


    var validate = function validate() {
      if (!hasForm()) return true;

      for (var i = 0; i < formConfig.value.length; i++) {
        var configItem = formConfig.value[i];

        if (configItem.isRequire == 1) {
          if (configItem.type == 1 && configItem.write.length < 1) {
            _Toast('请填写' + configItem.content);

            throw {
              message: '请填写' + configItem.content
            };
          } else if (configItem.type == 2 && configItem.optionCheckId == 0) {
            _Toast('请选择' + configItem.content);

            throw {
              message: '请填写' + configItem.content
            };
          } else if (configItem.type == 3 && configItem.preview.length < 1) {
            _Toast('请上传' + configItem.content);

            throw {
              message: '请填写' + configItem.content
            };
          } else if (configItem.type == 4 && (!configItem.optionCheckIds || configItem.optionCheckIds.length < 1)) {
            _Toast('请选择' + configItem.content);

            throw {
              message: '请选择' + configItem.content
            };
          } else if (configItem.type == 5 && !configItem.selectedValue) {
            _Toast('请选择' + configItem.content);

            throw {
              message: '请选择' + configItem.content
            };
          }
        }
      }

      return true;
    };
    /**
     * 提交表单配置，返回后端返回的 commitId
     * 后端判断选项超额时抛出错误（携带后端 msg），交由调用方展示
     */


    var commit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commitJson, i, configItem, li, _res, t, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                commitJson = [];
                i = 0;

              case 3:
                if (!(i < formConfig.value.length)) {
                  _context.next = 22;
                  break;
                }

                configItem = formConfig.value[i];

                if (!(configItem.type == 3)) {
                  _context.next = 12;
                  break;
                }

                configItem.uploadImg = [];

                for (li = 0; li < configItem.preview.length; li++) {
                  configItem.uploadImg.push(request.uploadFile(configItem.preview[li].file));
                }

                _context.next = 10;
                return Promise.all(configItem.uploadImg);

              case 10:
                _res = _context.sent;

                for (t = 0; t < _res.length; t++) {
                  if (t == 0) {
                    configItem.write = _res[t].filePath;
                  } else {
                    configItem.write = configItem.write + ',' + _res[t].filePath;
                  }
                }

              case 12:
                if (!(configItem.type == 4)) {
                  _context.next = 15;
                  break;
                }

                // 多选：选项 id 用逗号拼接上传
                commitJson[i] = {
                  content: configItem.write,
                  configId: configItem.id,
                  tagId: configItem.tagId,
                  optionsId: null,
                  optionsIds: configItem.optionCheckIds,
                  type: configItem.type
                };
                return _context.abrupt("continue", 19);

              case 15:
                if (!(configItem.type == 5)) {
                  _context.next = 18;
                  break;
                }

                // 日期：选中的是时间戳，上传时转成 YYYY-MM-DD 字符串
                commitJson[i] = {
                  content: configItem.selectedValue ? formatDateStr(configItem.selectedValue) : configItem.write,
                  configId: configItem.id,
                  tagId: configItem.tagId,
                  optionsId: null,
                  type: configItem.type
                };
                return _context.abrupt("continue", 19);

              case 18:
                commitJson[i] = {
                  content: configItem.write,
                  configId: configItem.id,
                  tagId: configItem.tagId,
                  optionsId: configItem.optionCheckId ? configItem.optionCheckId : null,
                  type: configItem.type
                };

              case 19:
                i++;
                _context.next = 3;
                break;

              case 22:
                _context.next = 24;
                return request.configCommit(commitJson);

              case 24:
                res = _context.sent;
                return _context.abrupt("return", res.data);

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 28]]);
      }));

      return function commit() {
        return _ref2.apply(this, arguments);
      };
    }();

    expose({
      getFormConfig: getFormConfig,
      validate: validate,
      commit: commit,
      hasForm: hasForm
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");

      var _component_van_icon = _resolveComponent("van-icon");

      var _component_van_radio = _resolveComponent("van-radio");

      var _component_van_radio_group = _resolveComponent("van-radio-group");

      var _component_van_button = _resolveComponent("van-button");

      var _component_van_popup = _resolveComponent("van-popup");

      var _component_van_checkbox = _resolveComponent("van-checkbox");

      var _component_van_checkbox_group = _resolveComponent("van-checkbox-group");

      var _component_van_picker = _resolveComponent("van-picker");

      var _component_van_uploader = _resolveComponent("van-uploader");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.value, function (item, index) {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [item.type == 1 ? (_openBlock(), _createBlock(_component_van_field, {
          key: 0,
          modelValue: item.write,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.write = $event;
          },
          required: item.isRequire == 1,
          label: item.content,
          placeholder: "请填写"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "required", "label"])) : _createCommentVNode("", true), item.type == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_van_field, {
          required: item.isRequire == 1,
          "is-link": "",
          readonly: "",
          label: item.content,
          "model-value": item.write,
          placeholder: "请选择",
          onClick: function onClick($event) {
            return item.showOption = true;
          }
        }, null, 8, ["required", "label", "model-value", "onClick"]), _createVNode(_component_van_popup, {
          show: item.showOption,
          "onUpdate:show": function onUpdateShow($event) {
            return item.showOption = $event;
          },
          round: "",
          position: "bottom",
          class: "option-popup",
          "lock-scroll": false
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.content), 1), _createElementVNode("div", {
              class: "popup-close",
              onClick: function onClick($event) {
                return item.showOption = false;
              }
            }, [_createVNode(_component_van_icon, {
              name: "cross",
              size: "13",
              color: "#999"
            })], 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_radio_group, {
              modelValue: item.radioValue,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.radioValue = $event;
              }
            }, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option, function (opt) {
                  return _openBlock(), _createElementBlock("div", {
                    key: opt.id,
                    class: _normalizeClass(["option-card", {
                      selected: item.radioValue === opt.id
                    }]),
                    onClick: function onClick($event) {
                      return item.radioValue = opt.id;
                    }
                  }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(opt.content), 1)]), _createVNode(_component_van_radio, {
                    name: opt.id,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
                  }, {
                    icon: _withCtx(function (props) {
                      return [_createElementVNode("span", {
                        class: _normalizeClass(["check-dot", {
                          checked: props.checked
                        }])
                      }, [props.checked ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "success",
                        size: "11",
                        color: "#fff"
                      })) : _createCommentVNode("", true)], 2)];
                    }),
                    _: 2
                  }, 1032, ["name"])], 10, _hoisted_6);
                }), 128))];
              }),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
              block: "",
              round: "",
              type: "primary",
              class: "confirm-btn",
              onClick: function onClick($event) {
                return confirmSingle(item);
              }
            }, {
              default: _withCtx(function () {
                return [_hoisted_10];
              }),
              _: 2
            }, 1032, ["onClick"])])];
          }),
          _: 2
        }, 1032, ["show", "onUpdate:show"])], 64)) : _createCommentVNode("", true), item.type == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createVNode(_component_van_field, {
          required: item.isRequire == 1,
          "is-link": "",
          readonly: "",
          label: item.content,
          "model-value": item.write,
          placeholder: "请选择",
          onClick: function onClick($event) {
            return item.showOption = true;
          }
        }, null, 8, ["required", "label", "model-value", "onClick"]), _createVNode(_component_van_popup, {
          show: item.showOption,
          "onUpdate:show": function onUpdateShow($event) {
            return item.showOption = $event;
          },
          round: "",
          position: "bottom",
          class: "option-popup",
          "lock-scroll": false
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.content), 1), _createElementVNode("div", {
              class: "popup-close",
              onClick: function onClick($event) {
                return item.showOption = false;
              }
            }, [_createVNode(_component_van_icon, {
              name: "cross",
              size: "13",
              color: "#999"
            })], 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_checkbox_group, {
              modelValue: item.checkboxValues,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.checkboxValues = $event;
              }
            }, {
              default: _withCtx(function () {
                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.option, function (opt) {
                  return _openBlock(), _createElementBlock("div", {
                    key: opt.id,
                    class: _normalizeClass(["option-card", {
                      selected: item.checkboxValues.includes(opt.id)
                    }]),
                    onClick: function onClick($event) {
                      return toggleMulti(item, opt.id);
                    }
                  }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(opt.content), 1)]), _createVNode(_component_van_checkbox, {
                    name: opt.id,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))
                  }, {
                    icon: _withCtx(function (props) {
                      return [_createElementVNode("span", {
                        class: _normalizeClass(["check-dot square", {
                          checked: props.checked
                        }])
                      }, [props.checked ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "success",
                        size: "11",
                        color: "#fff"
                      })) : _createCommentVNode("", true)], 2)];
                    }),
                    _: 2
                  }, 1032, ["name"])], 10, _hoisted_15);
                }), 128))];
              }),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_18, [item.checkboxValues.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, "已选 " + _toDisplayString(item.checkboxValues.length) + " 项", 1)) : _createCommentVNode("", true), _createVNode(_component_van_button, {
              block: "",
              round: "",
              type: "primary",
              class: "confirm-btn",
              onClick: function onClick($event) {
                return confirmMulti(item);
              }
            }, {
              default: _withCtx(function () {
                return [_hoisted_20];
              }),
              _: 2
            }, 1032, ["onClick"])])];
          }),
          _: 2
        }, 1032, ["show", "onUpdate:show"])], 64)) : _createCommentVNode("", true), item.type == 5 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 3
        }, [_createVNode(_component_van_field, {
          required: item.isRequire == 1,
          "is-link": "",
          readonly: "",
          label: item.content,
          "model-value": item.write,
          placeholder: "请选择",
          onClick: function onClick($event) {
            return item.showOption = true;
          }
        }, null, 8, ["required", "label", "model-value", "onClick"]), _createVNode(_component_van_popup, {
          show: item.showOption,
          "onUpdate:show": function onUpdateShow($event) {
            return item.showOption = $event;
          },
          round: "",
          position: "bottom",
          class: "option-popup",
          "lock-scroll": false
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(item.content), 1), _createElementVNode("div", {
              class: "popup-close",
              onClick: function onClick($event) {
                return item.showOption = false;
              }
            }, [_createVNode(_component_van_icon, {
              name: "cross",
              size: "13",
              color: "#999"
            })], 8, _hoisted_23)]), item.dateOptions.length ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_van_picker, {
              columns: item.dateOptions,
              "columns-field-names": customFieldName.value,
              "show-toolbar": false,
              onChange: function onChange($event) {
                return onDateChange(item, $event);
              }
            }, null, 8, ["columns", "columns-field-names", "onChange"])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_van_button, {
              block: "",
              round: "",
              type: "primary",
              class: "confirm-btn",
              onClick: function onClick($event) {
                return confirmDateClick(item);
              }
            }, {
              default: _withCtx(function () {
                return [_hoisted_26];
              }),
              _: 2
            }, 1032, ["onClick"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_van_icon, {
              name: "clock-o",
              size: "42",
              color: "#d8d8d8"
            }), _hoisted_28]))];
          }),
          _: 2
        }, 1032, ["show", "onUpdate:show"])], 64)) : _createCommentVNode("", true), item.type == 3 ? (_openBlock(), _createBlock(_component_van_field, {
          key: 4,
          required: item.isRequire == 1,
          name: "uploader",
          label: item.content
        }, {
          input: _withCtx(function () {
            return [_createVNode(_component_van_uploader, {
              modelValue: item.preview,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.preview = $event;
              },
              "max-count": item.picSize,
              "max-size": 10 * 1024 * 1024,
              multiple: "",
              onOversize: formOversize
            }, null, 8, ["modelValue", "onUpdate:modelValue", "max-count"])];
          }),
          _: 2
        }, 1032, ["required", "label"])) : _createCommentVNode("", true)], 64);
      }), 128))]);
    };
  }
};